<template>
  <div class="container-cadastro">

      
      <h1>Informações do imóvel</h1><br>
   <router-link v-if="getPermissao() != 3 " to="/busca" class="btn btn-danger float-right">VOLTAR</router-link>

    <router-link v-if="getPermissao() == 3 " to="/busca" class="btn btn-warning float-right">MINHAS CAPTAÇÕES</router-link>
   <!--<router-link v-if="getPermissao() == 3 " to="/cadastro" class="btn btn-warning float-right mr-3" >+CADASTRAR NOVO IMÓVEL</router-link> -->
   <div class="clearfix"></div>
   <img src="/img/venda.jpg" class="img-fluid " v-if="vl == 'Venda' || vl == 'Venda e Locação'"/>
    <img src="/img/locacao.jpg" class="img-fluid " v-if="vl == 'Locação' || vl == 'Venda e Locação'"/>
     <img src="/img/disponivel.jpg" class="img-fluid " v-if="checado"/>

     <!-- <img src="/img/ativo.jpg" class="img-fluid " v-if="ativo == 'Sim' "/>
    <img src="/img/suspenso.jpg" class="img-fluid " v-if="ativo == 'Não'"/>

     <img src="/img/destaque.jpg" class="img-fluid " v-if="destaque == 'Sim' "/>
          <img src="/img/anunciado.jpg" class="img-fluid " v-if="anunciado == 'Sim' "/>
          <img src="/img/disponivel.jpg" class="img-fluid " v-if="status == 'Disponível' "/>
          <img src="/img/indisponivel.jpg" class="img-fluid " v-if="status != 'Disponível' "/> -->
     <br> <br>

<h1 style="cursor:pointer;" @click="copiarLink" v-if="imovel != null">Referência: {{ referencia}}</h1>

    <!-- menus -->
    <ul class="nav nav-pills" v-if="imovel != null">
  <li class="nav-item">
    <a class="nav-link " :class="{active:tela == 1}" href="#" @click.prevent.stop="tela = 1">Cadastro</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" :class="{active:tela == 2}" href="#" @click.prevent.stop="tela = 2">Financeiro</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" :class="{active:tela == 3}" href="#" @click.prevent.stop="tela = 3">Fotos</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" :class="{active:tela == 4}" href="#" @click.prevent.stop="tela = 4">Contatos</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" :class="{active:tela == 5}" href="#" @click.prevent.stop="tela = 5">Anúncio</a>
  </li>
</ul>
    <!-- menus -->
<hr>
<Foto :imovel="imovel" v-if="tela === 3"></Foto>
<Financeiro :imovel="imovel" v-if="tela === 2"></Financeiro>
<Contato :imovel="imovel" v-if="tela === 4"></Contato>
<Anuncio :imovel="imovel" v-if="tela === 5"></Anuncio>


<br>
  <form class="row row-cols-sm-3" method="POST" ref="formulario" @submit.prevent.stop="sendForm" v-if="tela === 1">
    <input type="hidden" name="acao"  :value="acao"/>
     <input type="hidden" name="id"  :value="imovel"/>

     <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" >
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <p class="col-sm-12" style="margin:10px 0" v-if="imovel != null">Ultima atualização: {{ data }}<br>
        Data cadastro: {{ dataCadastro }}
        </p>

         <div v-if="showStatus" class="alert alert-info col-sm-12" role="alert">
       Informações atualizadas com sucesso!
       </div>

 <h4 class="col-sm-12" style="margin:10px 0">Informações do imóvel</h4>

 <div class="form-group col-sm">
        <label>Edificio:</label>
       

    <AutocompleteCustom ref="autocomplete" :resultados.sync="matches" :nome.sync="edificioSelecionado" @pronto="addEdificio" url="autocompleteEdificios" classe="autocompleteEdificios"></AutocompleteCustom>
    <!-- Button trigger modal -->
<button type="button" class="btn btn-warning btn-sm float-right" data-toggle="modal" data-target="#exampleModal">
  Descrição
</button>
  </div>


 <div class="form-group col-sm">
    <label>Tipo do imóvel</label>
    <select class="form-control" name="tipo" v-model="tipo">
       <option value=""></option>
      <option value="Apartamento">Apartamento</option>
      <option value="Apartamento sem condomínio">Apartamento sem condomínio</option>
      <option value="Cobertura">Cobertura</option>
      <option value="Casa térrea">Casa térrea</option>
      <option value="Sobrado">Sobrado</option>
       <option value="Sala">Sala</option>
        <option value="Galpão">Galpão</option>
         <option value="Outros">Outros</option>
    </select>
  </div>

  <div class="form-group col-sm">
        <label>Status do imóvel:</label>
         <img src="/img/check.png" style="width:50px;height:auto;display:inline-block;cursor:pointer;" class="img-fluid mt-n3" :class="{'colorless':checado == false}" @click="checkImovel"/>
        <select class="form-control" name="status" v-model="status">
        <option value="Disponível">Disponível</option>
        <option value="Locado">Locado</option>
        <option value="Vendido">Vendido</option>
        <option value="Suspenso">Suspenso</option>
     
    </select>
   
  </div>

   <div class="form-group col-sm-6">
    <label>Endereço:</label>
    <input type="text" name="endereco" class="form-control" value="" v-model="endereco" v-uppercase>
  </div>

  <div class="form-group col-sm-3">
    <label>Complemento:</label>
    <input type="text" name="complemento" class="form-control" value="" v-model="complemento" >
  </div>

 <div class="form-group col-sm-3">
        <label>Área útil:</label>
         <input type="number" name="areaUtil" class="form-control" value="" v-model="areaUtil">
  </div>

 <div class="form-group col-sm">
        <label>Cidade:</label>
        <select class="form-control" name="cidade" @change="getBairros" v-model="selectedCity">
        <option v-for="item in cidades" :key="item.CID_ID" :value="item.CID_ID">{{item.CID_NOME}}</option>
        
    </select>
  </div>

   <div class="form-group col-sm">
        <label>Bairro:</label>
        <select class="form-control" name="bairro" v-model="selectedBairro">
        <option v-for="item in bairros" :key="item.BAI_ID" :value="item.BAI_ID">{{item.BAI_NOME}}</option>
        
    </select>
  </div>

  

  

   <div class="form-group col-sm">
        <label>Estado:</label>
        <select class="form-control" name="estado" v-model="estado">
            <option value="AC">Acre</option>
            <option value="AL">Alagoas</option>
            <option value="AP">Amapá</option>
            <option value="AM">Amazonas</option>
            <option value="BA">Bahia</option>
            <option value="CE">Ceará</option>
            <option value="DF">Distrito Federal</option>
            <option value="ES">Espírito Santo</option>
            <option value="GO">Goiás</option>
            <option value="MA">Maranhão</option>
            <option value="MT">Mato Grosso</option>
            <option value="MS">Mato Grosso do Sul</option>
            <option value="MG">Minas Gerais</option>
            <option value="PA">Pará</option>
            <option value="PB">Paraíba</option>
            <option value="PR">Paraná</option>
            <option value="PE">Pernambuco</option>
            <option value="PI">Piauí</option>
            <option value="RJ">Rio de Janeiro</option>
            <option value="RN">Rio Grande do Norte</option>
            <option value="RS">Rio Grande do Sul</option>
            <option value="RO">Rondônia</option>
            <option value="RR">Roraima</option>
            <option value="SC">Santa Catarina</option>
            <option value="SP" selected="selected" >São Paulo</option>
            <option value="SE">Sergipe</option>
            <option value="TO">Tocantins</option>
        
    </select>
  </div>


   <div class="form-group col-sm-3">
        <label>CEP:</label>
        <input type="text" class="form-control" name="cep" v-model="cep" v-mask="'#####-###'">
        <option value=""></option>
        
    
  </div>



    <div class="form-group col-sm-3">
    <label>Finalidade</label>
    <select class="form-control" name="finalidade" v-model="finalidade">
       <option value=""></option>
      <option value="Residencial">Residencial</option>
      <option value="Comercial">Comercial</option>
      <option value="Religioso">Religioso</option>
     
    </select>
  </div>

 <div class="form-group col-sm-3">
        <label>Ocupação:</label>
        <select class="form-control" name="ocupacao" v-model="ocupacao">
       <option value=""></option>
        <option value="Vago">Vago</option>
        <option value="Ocupado">Ocupado</option>
     
    </select>
  </div>


 <div class="form-group col-sm-3">
        <label>Venda / Locação:</label>
        
        <select class="form-control" name="vl" v-model="vl">
        <option value="Venda">Venda</option>
        <option value="Locação">Locação</option>
        <option value="Venda e Locação">Venda e Locação</option>
     
    </select>
  </div>



  <h4 class="col-sm-12" style="margin:10px 0"><br>Características<hr></h4>

   <div class="form-group col-sm-1">
        <label>Dormitórios:</label>
         <input type="number" name="dormitorios" class="form-control" value="" v-model="dormitorios">
  </div>

   <div class="form-group col-sm-1">
        <label>suites:</label>
         <input type="number" name="suites" class="form-control" value="" v-model="suites">
  </div>

   <div class="form-group col-sm-1">
        <label>Banheiros:</label>
         <input type="number" name="banheiros" class="form-control" value="" v-model="banheiros">
  </div>

  <div class="form-group col-sm-1">
        <label>Andares:</label>
         <input type="number" name="andares" class="form-control" value="" v-model="andares">
  </div>

  <div class="form-group col-sm-2">
        <label>Aptos por Andar:</label>
         <input type="number" name="aptoAndar" class="form-control" value="" v-model="aptoAndar">
  </div>

   <div class="form-group col-sm-2">
        <label>N Torres:</label>
         <input type="number" name="torres" class="form-control" value="" v-model="torres">
  </div>
   <div class="form-group col-sm-2">
        <label>Ano construção:</label>
         <input type="number" name="ano" class="form-control" value="" v-model="ano">
  </div>


  <div class="form-group col-sm-2">
        <label>Ref. localização:</label>
         <input type="text" name="referenciaLocal" class="form-control" value="" v-model="referenciaLocal">
  </div>



  <div class="form-group col-sm-3">
        <label>Garagens:</label>
        <select class="form-control" name="garagens" v-model="garagens">
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>

   <div class="form-group col-sm-3">
        <label>Numero de garagens:</label>
         <input type="number" name="numeroGaragens" class="form-control" value="" v-model="numeroGaragens">
  </div>

    <div class="form-group col-sm-3">
        <label>Paralela:</label>
        <select class="form-control" name="paralela" v-model="paralela">
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>

    <div class="form-group col-sm-3">
        <label>Coberta:</label>
        <select class="form-control" name="coberta" v-model="coberta">
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>

   <div class="form-group col-sm d-none">
        <label>Observações:</label>
         <input type="text" name="observacoes" class="form-control" value="" v-model="observacoes">
  </div>

  <div class="form-group col-sm-12">
          <label>Observações do imóvel:</label>
          <textarea  name="observacaoImovel" class="form-control" v-model="observacaoImovel"></textarea>
        </div>

 

  <div class="form-group col-sm-3 d-none">
        <label>Lazer:</label>
        <select class="form-control" name="lazer" v-model="lazer">
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>

   


  <div class="col-sm-9 mt-4">

   <!-- <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Quadra" v-model="tipoLazer">
      <label class="form-check-label">
       Quadra
      </label>
    </div>

     <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Quadra de tênis" v-model="tipoLazer">
      <label class="form-check-label">
       Quadra de tênis
      </label>
    </div>

    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Piscina" v-model="tipoLazer">
      <label class="form-check-label">
       Piscina
      </label>
    </div>

    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Academia" v-model="tipoLazer">
      <label class="form-check-label">
       Academia
      </label>
    </div> -->

  </div><!-- div checks -->




  <!-- -->

        


  
       


       


     <div class="form-group col-sm d-none" v-if="imovel != null">
    <label>Referência:</label>
    <input type="text" name="referencia" readonly class="form-control" value="" v-model="referencia">
  </div>

  


 

  <!--<div class="form-group col-sm" v-if="imovel != null">
    <label>Referência:</label>
    <input type="text" name="referencia2" readonly class="form-control" value="" v-model="referencia2">
  </div> -->



   

 <h5 class="col-sm-12" style="margin:10px 0"><br>Diferenciais do imóvel<hr></h5>
 <div class="col-sm-12">

    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="diferencial[]" value="Aceita animais" v-model="diferencial">
      <label class="form-check-label">
       Aceita animais
      </label>
    </div>

     <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="diferencial[]" value="Ar condicionado" v-model="diferencial">
      <label class="form-check-label">
      Ar condicionado
      </label>
    </div>

    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="diferencial[]" value="Closet" v-model="diferencial">
      <label class="form-check-label">
      Closet
      </label>
    </div>

    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="diferencial[]" value="Cozinha americana" v-model="diferencial">
      <label class="form-check-label">
       Cozinha americana
      </label>
    </div>

    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="diferencial[]" value="Lareira" v-model="diferencial">
      <label class="form-check-label">
       Lareira
      </label>
    </div>

    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="diferencial[]" value="Mobiliado" v-model="diferencial">
      <label class="form-check-label">
       Mobiliado
      </label>
    </div>

     <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" name="diferencial[]" value="Varanda Gourmet" v-model="diferencial">
      <label class="form-check-label">
      Varanda Gourmet
      </label>
    </div>

  </div><!-- div checks -->

 <h5 class="col-sm-12" style="margin:10px 0"><br>Outras caracteristicas do imóvel<hr></h5>
 <div class="col-sm-4">

    <div class="form-check form-check-inline d-block">
      <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Conexão à internet" v-model="caracteristicas">
      <label class="form-check-label">
         Conexão à internet
      </label>
    </div>

    <div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Ambientes integrados" v-model="caracteristicas">
  <label class="form-check-label">Ambientes integrados</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Armário embutido" v-model="caracteristicas">
  <label class="form-check-label">Armário embutido</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Área de serviço" v-model="caracteristicas">
  <label class="form-check-label">Área de serviço</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Armário embutido no quarto" v-model="caracteristicas">
  <label class="form-check-label">Armário embutido no quarto</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Armário na cozinha" v-model="caracteristicas">
  <label class="form-check-label">Armário na cozinha</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Armário no banheiro" v-model="caracteristicas">
  <label class="form-check-label">Armário no banheiro</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Banheira" v-model="caracteristicas">
  <label class="form-check-label">Banheira</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Box Blindex" v-model="caracteristicas">
  <label class="form-check-label">Box Blindex</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Gesso / Sanca / Teto Rebaixado" v-model="caracteristicas">
  <label class="form-check-label">Gesso - Sanca - Teto Rebaixado</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Piso de madeira" v-model="caracteristicas">
  <label class="form-check-label">Piso de madeira</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Piso laminado" v-model="caracteristicas">
  <label class="form-check-label">Piso laminado</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Piso frio" v-model="caracteristicas">
  <label class="form-check-label">Piso frio</label>
</div>

 </div><!-- div checks -->
  <div class="col-sm-4">

    <div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Churrasqueira na varanda" v-model="caracteristicas">
  <label class="form-check-label">Churrasqueira na varanda</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Chuveiro a gás" v-model="caracteristicas">
  <label class="form-check-label">Chuveiro a gás</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Cozinha gourmet" v-model="caracteristicas">
  <label class="form-check-label">Cozinha gourmet</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Cozinha grande" v-model="caracteristicas">
  <label class="form-check-label">Cozinha grande</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Dependência de empregados" v-model="caracteristicas">
  <label class="form-check-label">Dependência de empregados</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Depósito" v-model="caracteristicas">
  <label class="form-check-label">Depósito</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Despensa" v-model="caracteristicas">
  <label class="form-check-label">Despensa</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Escada" v-model="caracteristicas">
  <label class="form-check-label">Escada</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Escritório" v-model="caracteristicas">
  <label class="form-check-label">Escritório</label>
</div>

 </div><!-- div checks -->
  <div class="col-sm-4">

   <div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Fogão" v-model="caracteristicas">
  <label class="form-check-label">Fogão</label>
</div>

<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Hidromassagem" v-model="caracteristicas">
  <label class="form-check-label">Hidromassagem</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Interfone" v-model="caracteristicas">
  <label class="form-check-label">Interfone</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Lavabo" v-model="caracteristicas">
  <label class="form-check-label">Lavabo</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Piscina Privativa" v-model="caracteristicas">
  <label class="form-check-label">Piscina Privativa</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Porcelanato" v-model="caracteristicas">
  <label class="form-check-label">Porcelanato</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Sala grande" v-model="caracteristicas">
  <label class="form-check-label">Sala grande</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Varanda" v-model="caracteristicas">
  <label class="form-check-label">Varanda</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="caracteristicas[]" value="Varanda fechada com vidro" v-model="caracteristicas">
  <label class="form-check-label">Varanda fechada com vidro</label>
</div>

 </div><!-- div checks -->

<h5 class="col-sm-12" style="margin:10px 0"><br>Lazer, esporte, comodidade, serviços e segurança<hr></h5>
<div class="col-sm-4">

   <div class="form-check form-check-inline d-block">
      <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Quadra" v-model="tipoLazer">
      <label class="form-check-label">
       Quadra
      </label>
    </div>

     <div class="form-check form-check-inline d-block">
      <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Quadra de tênis" v-model="tipoLazer">
      <label class="form-check-label">
       Quadra de tênis
      </label>
    </div>

    <div class="form-check form-check-inline d-block">
      <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Piscina" v-model="tipoLazer">
      <label class="form-check-label">
       Piscina
      </label>
    </div>

    <div class="form-check form-check-inline d-block">
      <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Academia" v-model="tipoLazer">
      <label class="form-check-label">
       Academia
      </label>
    </div>

 <div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Churrasqueira" v-model="tipoLazer">
  <label class="form-check-label">Churrasqueira</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Cinema" v-model="tipoLazer">
  <label class="form-check-label">Cinema</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Espaço gourmet" v-model="tipoLazer">
  <label class="form-check-label">Espaço gourmet</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Jardim" v-model="tipoLazer">
  <label class="form-check-label">Jardim</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Playground" v-model="tipoLazer">
  <label class="form-check-label">Playground</label>
</div>

</div>
<div class="col-sm-4">
  <div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Salão de festas" v-model="tipoLazer">
  <label class="form-check-label">Salão de festas</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Salão de jogos" v-model="tipoLazer">
  <label class="form-check-label">Salão de jogos</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Acesso a deficientes" v-model="tipoLazer">
  <label class="form-check-label">Acesso a deficientes</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Bicicletário" v-model="tipoLazer">
  <label class="form-check-label">Bicicletário</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Elevador" v-model="tipoLazer">
  <label class="form-check-label">Elevador</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Sauna" v-model="tipoLazer">
  <label class="form-check-label">Sauna</label>
</div>

<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Condomínio Fechado" v-model="tipoLazer">
  <label class="form-check-label">Condomínio Fechado</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Portão Eletrônico" v-model="tipoLazer">
  <label class="form-check-label">Portão Eletrônico</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="tipoLazer[]" value="Portaria 24h" v-model="tipoLazer">
  <label class="form-check-label">Portaria 24h</label>
</div>

</div>


 <h5 class="col-sm-12" style="margin:10px 0"><br>Outras caracteristicas do condomínio<hr></h5>
 <div class="col-sm-4">
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Área de lazer" v-model="condominio">
  <label class="form-check-label">Área de lazer</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Brinquedoteca" v-model="condominio">
  <label class="form-check-label">Brinquedoteca</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Câmera de segurança" v-model="condominio">
  <label class="form-check-label">Câmera de segurança</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Centro de estética" v-model="condominio">
  <label class="form-check-label">Centro de estética</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Cerca" v-model="condominio">
  <label class="form-check-label">Cerca</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Circuito de Segurança" v-model="condominio">
  <label class="form-check-label">Circuito de Segurança</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Entrada de serviço" v-model="condominio">
  <label class="form-check-label">Entrada de serviço</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Espaço teen" v-model="condominio">
  <label class="form-check-label">Espaço teen</label>
</div>

 </div>

 <div class="col-sm-4">

   <div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Espaço pet" v-model="condominio">
  <label class="form-check-label">Espaço pet</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Estacionamento para visitantes" v-model="condominio">
  <label class="form-check-label">Estacionamento para visitantes</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Guarita" v-model="condominio">
  <label class="form-check-label">Guarita</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Hall de entrada" v-model="condominio">
  <label class="form-check-label">Hall de entrada</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Piscina aquecida" v-model="condominio">
  <label class="form-check-label">Piscina aquecida</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Piscina para adulto" v-model="condominio">
  <label class="form-check-label">Piscina para adulto</label>
</div>
<div class="form-check form-check-inline d-block">
  <input class="form-check-input" type="checkbox" name="condominio[]" value="Piscina infantil" v-model="condominio">
  <label class="form-check-label">Piscina infantil</label>
</div>
 </div>

 <h4 class="col-sm-12" style="margin:10px 0"><br>Informações complementares<hr></h4>

  

   <div class="form-group col-sm-1">
        <label>Terreno:</label>
         <input type="text" name="terreno" class="form-control" value="" v-model="terreno">
  </div>

   <div class="form-group col-sm-2">
        <label>Área construida:</label>
         <input type="text" name="area" class="form-control" value="" v-model="areaConstruida">
  </div>

   <div class="form-group col-sm-2">
        <label>Dimensões:</label>
         <input type="text" name="dimensoes" class="form-control" value="" v-model="dimensoes">
  </div>

   <div class="form-group col-sm-2">
        <label>Contrapiso:</label>
        <select class="form-control" name="contrapiso" v-model="contrapiso">
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>

   <div class="form-group col-sm-2">
        <label>Planejados:</label>
        <select class="form-control" name="planejados" v-model="planejados">
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>

   <div class="form-group col-sm-3">
        <label>Chaves:</label>
         <input type="text" name="chaves" class="form-control" value="" v-model="chaves">
  </div>

    <div class="form-group col-sm">
        <label>Placa:</label>
        <select class="form-control" name="placa" v-model="placa">
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>


    <div class="form-group col-sm">
        <label>Ativo:</label>
        <select class="form-control" name="ativo" v-model="ativo">
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>

    <div class="form-group col-sm">
        <label>Destaque:</label>
        <select class="form-control" name="destaque" v-model="destaque">
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>


  <div class="form-group col-sm-4 offset-sm-4">
        <label></label>
        <input type="submit" class="btn btn-info form-control" value="ENVIAR DADOS" />
    </div>

    

 
 <br> <br> <br> <br> <br> <br>
  </form>

<!--------- -------->

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Descrição do edificio</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{ descricao }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      
      </div>
    </div>
  </div>
</div>



<!--- -------->


  </div>
</template>
<style>
.colorless{filter: grayscale(1);}
</style>
<script>
import axios from 'axios'
import Foto from '../views/Foto.vue'
import Financeiro from '../views/Financeiro.vue'
import Contato from '../views/Contato.vue'
import Anuncio from '../views/Anuncio.vue'
import AutocompleteCustom from '@/components/AutocompleteCustom'

export default {
  name: 'Cadastro',
  components: {Anuncio,Foto,Financeiro,Contato,AutocompleteCustom},
  data(){
      return {
        checado:false,
        dataChecagem:'',
        dataCadastro:"",
        observacaoImovel:'',
        descricao:'',
        complemento:'',
          anunciado:'',
          imovel: null,
          data:'',
          acao:1,
          ocupacao: '',
          referencia:'',
          vl: 'Venda',
          tipo:'',
          finalidade:'',
          edificio:'',
          cidade:'',
          endereco:'',
          bairro:'',
          estado:'SP',
          cep:'',
          andares:'',
          aptoAndar:'',
          observacoes:'',
          referenciaLocal:'',
           dormitorios:'',
           suites:'',
            banheiros:'',
             garagens:'',
              numeroGaragens:'',
               paralela:'',
                coberta:'',
                lazer:'',
                areaUtil:'',
                terreno:'',
                areaConstruida:'',
               dimensoes:'',
               contrapiso:'',
               planejados:'',
               chaves:'',
               placa:'',
              ativo:'',
              destaque:'',
             tipoLazer: [],
             edificios:[],
             cidades:[],
              bairros:[],
             selectedCity:0,
             selectedEdificio:1119,
             selectedBairro:0,
             showStatus:false,
             tela:1,
             status:"",
             loading:false,
             edificioSelecionado:'',
             matches:[],
             diferencial: [],
             caracteristicas: [],
             condominio: [],
             torres:0,
             ano:''
      }
  },
  methods:{
     copiarLink(){
   
       window.navigator.clipboard.writeText("https://www2.royaljardim.com.br/site/imovel/"+this.referencia).then(() => {
        console.log('Content copied to clipboard');
        /* Resolved - text copied to clipboard successfully */
      },() => {
        console.error('Failed to copy');
        /* Rejected - text failed to copy to the clipboard */
      });
  },
    checkImovel(){
        this.loading = true;
          axios
          .get('https://www2.royaljardim.com.br/sistema/welcome/checkImovel/'+ this.referencia)
          .then(response => {console.log(response);
                           this.getimovel();
                           this.showStatus = true;
                            })
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },
    reload(){
      this.$router.go(0);
    },
    getPermissao(){
       return sessionStorage.getItem('imobiliaria');
     },
      getUsuario(){
       return sessionStorage.getItem('imobiliariaNome');
     },
    addEdificio(valor){
      this.selectedEdificio = valor.ED_ID;
      this.descricao = valor.ED_DESCRICAO;
     
    },
     getEdificio(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getEdificio',{id:this.selectedEdificio})
          .then(response => {this.edificioSelecionado = response.data.ED_NOME;
           this.$refs.autocomplete.preencher(response.data.ED_NOME);
          this.descricao = response.data.ED_DESCRICAO;})
          .catch(response => console.log(response))
          
    },
     getCidades(){
          this.loading = true;
          axios
          .get('https://www2.royaljardim.com.br/sistema/welcome/getCidades')
          .then(response => {this.cidades = response.data;
           if(this.$route.params.id == null){
              this.cidades.unshift({CID_ID: 5,CID_NOME : "Santo André"});
          }
          })
          .catch(response => console.log(response))
          .finally(() =>  {
                           this.loading = false; 
                          
                              this.selectedCity = this.cidades[0].CID_ID;
                           
                           
                           
                           })
    },
    getBairros(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getBairros',{cidade:this.selectedCity})
          .then(response => {this.bairros = response.data;
                             
                              })
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

   sendForm(){
    let formData = new FormData(this.$refs["formulario"]); 
    formData.append('edificio',this.selectedEdificio);
    formData.append('captador',this.getUsuario());
       
        this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/novoImovel',formData)
          .then(response => {console.log(response);
                            if(this.acao == 1 ){
                                this.imovel = response.data;
                            }
                           this.getimovel();
                           this.showStatus = true;
                            })
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

     getimovel(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getImovel',{imovel:this.imovel})
          .then(response => this.updateInfo(response.data))
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    updateInfo(dados){
          this.acao = 2;
          this.ocupacao = dados.IM_OCUPACAO;
          this.vl = dados.IM_VENDALOCACAO;
          this.tipo = dados.IM_TIPO;
          this.finalidade = dados.IM_FINALIDADE;
          this.selectedEdificio = dados.IM_EDIFICIO;
          this.cidade = dados.IM_CIDADE;
          this.selectedCity = dados.IM_CIDADE;
          this.endereco = dados.IM_ENDERECO;
          this.selectedBairro = dados.IM_BAIRRO;
         this.estado = dados.IM_ESTADO;
         this.cep = dados.IM_CEP;
         this.andares = dados.IM_ANDARES;
         this.aptoAndar = dados.IM_APTOSANDAR;
         this.observacoes = dados.IM_OBSERVACOES;
         this.referenciaLocal = dados.IM_REFLOCALIZACAO;
          this.dormitorios = dados.IM_DORMITORIOS;
          this.suites = dados.IM_SUITES;
           this.banheiros = dados.IM_BANHEIROS;
            this.garagens = dados.IM_GARAGENS;
             this.numeroGaragens = dados.IM_NUMERO_GARAGENS;
             this.paralela = dados.IM_PARALELA;
              this.coberta = dados.IM_COBERTA;
               this.lazer = dados.IM_LAZER;
               this.areaUtil = dados.IM_AREAUTIL;
                this.terreno = dados.IM_TERRENO;
                this.areaConstruida = dados.IM_AREA_CONSTRUIDA;
               this.dimensoes = dados.IM_DIMENSOES;
               this.contrapiso = dados.IM_CONTRAPISO;
               this.planejados = dados.IM_PLANEJADOS;
               this.chaves = dados.IM_CHAVES;
               this.placa = dados.IM_PLACA;
              this.ativo = dados.IM_ATIVO;
              this.destaque = dados.IM_DESTAQUE;
              this.anunciado = dados.IM_ANUNCIADO;
              this.complemento = dados.IM_COMPLEMENTO;
              this.tipoLazer = (dados.IM_ITENSLAZER != null) ? dados.IM_ITENSLAZER.split("-"):[];
               this.diferencial = (dados.IM_ITENS_DIFERENCIAIS != null) ? dados.IM_ITENS_DIFERENCIAIS.split("-"):[];
                  this.caracteristicas = (dados.IM_ITENS_CARACTERISTICAS != null) ? dados.IM_ITENS_CARACTERISTICAS.split("-"):[];
                     this.condominio = (dados.IM_ITENS_CONDOMINIO != null) ? dados.IM_ITENS_CONDOMINIO.split("-"):[];
              this.observacaoImovel = dados.IM_OBSERVACAO_IMOVEL;
              this.torres = dados.IM_TORRES;
              this.ano = dados.IM_CONSTRUCAO;
             
             this.referencia = dados.IM_ID;
             this.data = dados.IM_UPDATED;
             this.dataCadastro = dados.IM_DATA_ENTRADA;
             this.dataChecagem = dados.IM_DATA_CHECAGEM;
             this.checado = dados.CHECADO;
             console.log( this.checado);
             this.status = dados.IM_STATUS;
             this.getEdificio();
             this.getBairros();
    }
  },

  computed:{
   
      
  },
  mounted () {
    this.getCidades();

    if(this.$route.params.id != null){
     
      this.imovel = this.$route.params.id;
      this.getimovel();
    }

  }

}
</script>
